import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import {
  TimingMarker,
  TimingPair,
} from "@faire/web--source/common/timings/TimingMarker";
import { uuid } from "@faire/web--source/common/uuid";

export const TIMING_KEYS = {
  VIEW_CART: "track-view-cart-latency",
  BUY_IT_AGAIN_CHECKOUT: "track-buy-it-again-checkout-latency",
  CHECKOUT_SINGLE_BRAND: "track-checkout-single-brand-latency",
  CHECKOUT_ALL_BRANDS: "track-checkout-all-brands-latency",
  PLACE_ORDER: "track-place-order-latency",
};

export class TimingRecorder {
  private timers: { [key: string]: TimingMarker } = {};

  static get = singletonGetter(TimingRecorder);

  recordTime = (key?: string): string => {
    if (!key) {
      key = uuid();
    }
    this.timers[key] = new TimingMarker();
    return key;
  };

  clearTiming = (key: string): void => {
    if (key in this.timers) {
      delete this.timers[key];
    }
  };

  private getTimingPair = (key: string): TimingPair | null => {
    if (this.timers[key]) {
      return {
        start: this.timers[key]!,
        end: new TimingMarker(),
      };
    }
    return null;
  };

  trackTiming = (
    key: string,
    peteFunction: (timingPair: TimingPair) => void
  ): void => {
    const timingPair = this.getTimingPair(key);
    if (timingPair) {
      this.clearTiming(key);
      peteFunction(timingPair);
    }
  };
}
